import { useEffect, useState } from "react";

export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function useCountdown(target) {
  const now = useNow(1000);
  const diff = Math.max((target || 0) - now, 0);
  const s = Math.floor(diff / 1000);
  const pad = (n) => String(n).padStart(2, "0");
  return {
    done: diff === 0,
    dd: pad(Math.floor(s / 86400)),
    hh: pad(Math.floor((s % 86400) / 3600)),
    mm: pad(Math.floor((s % 3600) / 60)),
    ss: pad(s % 60),
  };
}
